module.exports = __webpack_public_path__ + "static/media/englishPage5.b7895546.jpg";